import React, { useEffect, useState } from 'react';
import { Trophy, Target, Users, Award, Heart, Sparkles } from 'lucide-react';
import { apiService } from '../services/api';

const DEFAULT_CONTACT = {
  title: 'Ingin Bergabung dengan IJSL?',
  description: 'Daftarkan tim Anda sekarang dan jadilah bagian dari kompetisi sepak bola junior terbaik di Indonesia!',
  button_text: 'Hubungi Kami',
  button_link: 'https://wa.me/6281234567890',
  email: 'admin@ijsl.co.id',
  phone: '+62 812-3456-7890',
  whatsapp: '+62 812-3456-7890',
  address: 'Jakarta, Indonesia',
};

const TentangKami = () => {
  const [contact, setContact] = useState(DEFAULT_CONTACT);

  useEffect(() => {
    const loadContactConfig = async () => {
      try {
        const response = await apiService.getPublicAppConfig('hubungi_kami');
        const values = response?.data?.values;
        if (Array.isArray(values) && values[0] && typeof values[0] === 'object') {
          setContact({ ...DEFAULT_CONTACT, ...values[0] });
        }
      } catch (error) {
        setContact(DEFAULT_CONTACT);
      }
    };

    loadContactConfig();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-green-600 to-green-700 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <img
            src="https://customer-assets.emergentagent.com/job_90560e06-7136-451f-8b9f-e5b1a310f4fa/artifacts/3z4o6h4i_2133.png"
            alt="IJSL Logo"
            className="h-32 w-auto mx-auto mb-6 brightness-0 invert"
          />
          <h1 className="text-5xl font-bold mb-4">Indonesia Junior Soccer League</h1>
          <p className="text-xl text-green-100 max-w-3xl mx-auto">
            Membangun Generasi Pemain Sepak Bola Muda Indonesia yang Berkualitas
          </p>
        </div>
      </div>

      {/* Vision & Mission */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="flex items-center space-x-3 mb-6">
                <div className="bg-green-100 p-3 rounded-full">
                  <Target className="h-8 w-8 text-green-600" />
                </div>
                <h2 className="text-3xl font-bold text-gray-900">Visi</h2>
              </div>
              <p className="text-gray-700 leading-relaxed text-lg">
                Menjadi kompetisi sepak bola junior terbaik di Indonesia yang melahirkan pemain-pemain muda berbakat dan berkarakter untuk mengharumkan nama bangsa di kancah internasional.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="flex items-center space-x-3 mb-6">
                <div className="bg-green-100 p-3 rounded-full">
                  <Trophy className="h-8 w-8 text-green-600" />
                </div>
                <h2 className="text-3xl font-bold text-gray-900">Misi</h2>
              </div>
              <ul className="space-y-3 text-gray-700 text-lg">
                <li className="flex items-start space-x-2">
                  <span className="text-green-600 font-bold mt-1">•</span>
                  <span>Menyelenggarakan kompetisi berkualitas tinggi</span>
                </li>
                <li className="flex items-start space-x-2">
                  <span className="text-green-600 font-bold mt-1">•</span>
                  <span>Mengembangkan bakat pemain muda Indonesia</span>
                </li>
                <li className="flex items-start space-x-2">
                  <span className="text-green-600 font-bold mt-1">•</span>
                  <span>Membangun karakter sportif dan disiplin</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-gray-900 text-center mb-12">Nilai-Nilai Kami</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="bg-green-100 w-20 h-20 rounded-full mx-auto mb-4 flex items-center justify-center">
                <Trophy className="h-10 w-10 text-green-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Prestasi</h3>
              <p className="text-gray-600">
                Mendorong pencapaian terbaik dalam setiap pertandingan
              </p>
            </div>

            <div className="text-center">
              <div className="bg-blue-100 w-20 h-20 rounded-full mx-auto mb-4 flex items-center justify-center">
                <Users className="h-10 w-10 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Kebersamaan</h3>
              <p className="text-gray-600">
                Membangun kerjasama dan solidaritas antar tim
              </p>
            </div>

            <div className="text-center">
              <div className="bg-purple-100 w-20 h-20 rounded-full mx-auto mb-4 flex items-center justify-center">
                <Award className="h-10 w-10 text-purple-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Sportivitas</h3>
              <p className="text-gray-600">
                Menjunjung tinggi fair play dalam berkompetisi
              </p>
            </div>

            <div className="text-center">
              <div className="bg-orange-100 w-20 h-20 rounded-full mx-auto mb-4 flex items-center justify-center">
                <Heart className="h-10 w-10 text-orange-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Dedikasi</h3>
              <p className="text-gray-600">
                Komitmen penuh untuk pengembangan sepak bola muda
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* About */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="flex items-center space-x-3 mb-6">
                <Sparkles className="h-8 w-8 text-green-600" />
                <h2 className="text-3xl font-bold text-gray-900">Tentang IJSL</h2>
              </div>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  Indonesia Junior Soccer League (IJSL) adalah kompetisi sepak bola khusus untuk pemain muda kategori U-12 dan U-14. Didirikan dengan tujuan memberikan wadah kompetisi yang berkualitas bagi pemain-pemain muda Indonesia untuk mengasah kemampuan dan mengembangkan bakat mereka.
                </p>
                <p>
                  Sejak didirikan, IJSL telah menjadi salah satu kompetisi junior terbesar dan paling bergengsi di Indonesia. Kami berkomitmen untuk memberikan pengalaman berkompetisi yang profesional dengan standar internasional, sambil tetap memperhatikan aspek pendidikan dan pembentukan karakter pemain.
                </p>
                <p>
                  IJSL tidak hanya fokus pada aspek kompetisi, tetapi juga pada pengembangan holistik pemain muda. Kami percaya bahwa sepak bola adalah media yang sempurna untuk mengajarkan nilai-nilai penting seperti kerja keras, disiplin, kerjasama, dan sportivitas.
                </p>
                <p>
                  Dengan dukungan dari berbagai pihak, termasuk sekolah sepak bola, sponsor, dan orang tua, IJSL terus berkembang dan memberikan kontribusi nyata bagi perkembangan sepak bola Indonesia di tingkat akar rumput.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Statistics */}
      <section className="py-16 bg-gradient-to-br from-green-600 to-green-700 text-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-12">IJSL dalam Angka</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <p className="text-5xl font-bold mb-2">50+</p>
              <p className="text-green-100">Tim Peserta</p>
            </div>
            <div className="text-center">
              <p className="text-5xl font-bold mb-2">200+</p>
              <p className="text-green-100">Pertandingan</p>
            </div>
            <div className="text-center">
              <p className="text-5xl font-bold mb-2">1000+</p>
              <p className="text-green-100">Pemain Muda</p>
            </div>
            <div className="text-center">
              <p className="text-5xl font-bold mb-2">10+</p>
              <p className="text-green-100">Kota</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="bg-white rounded-lg shadow-lg p-12 text-center max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              {contact.title}
            </h2>
            <p className="text-gray-600 mb-8 text-lg">
              {contact.description}
            </p>
            <a
              href={contact.button_link || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-lg transition-colors duration-200"
            >
              {contact.button_text || 'Hubungi Kami'}
            </a>

            <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
              {contact.email && (
                <div className="rounded-lg border border-gray-200 p-3">
                  <p className="text-xs uppercase tracking-wide text-gray-500">Email</p>
                  <p className="text-sm font-medium text-gray-800">{contact.email}</p>
                </div>
              )}
              {contact.phone && (
                <div className="rounded-lg border border-gray-200 p-3">
                  <p className="text-xs uppercase tracking-wide text-gray-500">Telepon</p>
                  <p className="text-sm font-medium text-gray-800">{contact.phone}</p>
                </div>
              )}
              {contact.whatsapp && (
                <div className="rounded-lg border border-gray-200 p-3">
                  <p className="text-xs uppercase tracking-wide text-gray-500">WhatsApp</p>
                  <p className="text-sm font-medium text-gray-800">{contact.whatsapp}</p>
                </div>
              )}
              {contact.address && (
                <div className="rounded-lg border border-gray-200 p-3">
                  <p className="text-xs uppercase tracking-wide text-gray-500">Alamat</p>
                  <p className="text-sm font-medium text-gray-800">{contact.address}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TentangKami;